import { render, staticRenderFns } from "./FundingSoon.vue?vue&type=template&id=c908464c&"
import script from "./FundingSoon.vue?vue&type=script&lang=js&"
export * from "./FundingSoon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports